import React from 'react';
import type { Betslip as BetslipTypes } from '@gin-betting/betslip';
import { App } from '@gin-betting/core';

import UserDevice from 'services/user-device';
import BetslipFooter from '../BetslipFooter';
import Body from '../Body';
import Tabs from '../Tabs';
import useBetslip from './useBetslip';
import useValidBetslipProps from './useValidBetslipProps';

import './betslip.scss';

type Props = {
    betslipBetId: string;
    isOpened: boolean;
};

interface BetslipProps extends Props {
    betslipBet: BetslipTypes.BetslipBetWithStatus;
}

const Betslip: React.FC<BetslipProps> = ({
    betslipBetId,
    betslipBet,
    isOpened,
}) => {
    const {
        betslipOddIdsGroup,
        disabledModes,
        mode,
        status,
        isFooterDisabled,
        handleChangeMode,
        systemSize,
        betslipOddsSize,
        isSingle,
    } = useBetslip({
        betslipBet,
        betslipBetId,
    });

    const isSuccess = status === App.BetslipStatus.SUCCESS;

    if (!isOpened) return null;

    let systemSizeTitle: string | undefined;

    if (UserDevice.getInstance()?.isDeviceMobile()) {
        systemSizeTitle = systemSize
            .map(i => `${i}/${betslipOddsSize}`)
            .join(' ');
    }

    return (
        <div styleName="container" className="__app-Betslip-container">
            <Tabs
                mode={mode}
                handleChangeMode={handleChangeMode}
                disabledModes={disabledModes}
                systemPrefix={systemSizeTitle}
            />
            <Body betslipOddIdsGroup={betslipOddIdsGroup} />
            {(!isSuccess || isSingle) && (
                <BetslipFooter
                    mode={mode}
                    isDisabled={isFooterDisabled}
                    betslipBetId={betslipBetId}
                />
            )}
        </div>
    );
};

const BetslipValidationProps: React.FC<Props> = ({
    betslipBetId,
    isOpened,
}) => {
    const validProps = useValidBetslipProps({ betslipBetId });

    if (!validProps) return null;

    const { betslipBet } = validProps;

    return (
        <Betslip
            betslipBet={betslipBet}
            betslipBetId={betslipBetId}
            isOpened={isOpened}
        />
    );
};

export default BetslipValidationProps;
